import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Säilita

  <span style="color:#85c1dc;">**FI:**</span>
  Tallennan

  <span style="color:#85c1dc;">**RU:**</span>
  Сохранить
*/
/* @__NO_SIDE_EFFECTS__ */
const m824 = msg(
  mf`Säilita`,
  mf`Tallennan`,
  mf`Сохранить`,
)

export { m824 as 'w.basket.merge.button.keep' }